import React from "react";
const Testimonials = () => <section>hey i'm Projects Testimonials</section>;
export default Testimonials;
